var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.7571C14 18.1658 13.3679 16.6397 12.2426 15.5144C11.1174 14.3892 9.5913 13.7571 8 13.7571C6.4087 13.7571 4.88258 14.3892 3.75736 15.5144C2.63214 16.6397 2 18.1658 2 19.7571",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.7571C10.2091 13.7571 12 11.9662 12 9.75708C12 7.54794 10.2091 5.75708 8 5.75708C5.79086 5.75708 4 7.54794 4 9.75708C4 11.9662 5.79086 13.7571 8 13.7571Z",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.7571C22 18.1658 21.3679 16.6397 20.2426 15.5144C19.1174 14.3892 17.5913 13.7571 16 13.7571C17.0609 13.7571 18.0783 13.3357 18.8284 12.5855C19.5786 11.8354 20 10.8179 20 9.75708C20 8.69621 19.5786 7.6788 18.8284 6.92865C18.0783 6.17851 17.0609 5.75708 16 5.75708",
    stroke: "#006AFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/active-users.ea8ce73239770f0cce2f3820467581fd.svg";
export { ForwardRef as ReactComponent };